import { Controller } from "stimulus"
import GLightbox from 'glightbox';
export default class extends Controller {
  initialize() {
    const lightbox = new GLightbox({openEffect: "none", closeEffect: "none"});
  }
}
